import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './storage-site.reducer';

export const StorageSiteDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const storageSiteEntity = useAppSelector(state => state.storageSite.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="storageSiteDetailsHeading">
          <Translate contentKey="coconApp.storageSite.detail.title">StorageSite</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{storageSiteEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="coconApp.storageSite.name">Name</Translate>
            </span>
          </dt>
          <dd>{storageSiteEntity.name}</dd>
        </dl>
        <Button tag={Link} to="/storage-site" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/storage-site/${storageSiteEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default StorageSiteDetail;
